class FlutterAppData {
  static instance: FlutterAppData
  static getInstance() {
    if (!FlutterAppData.instance) {
      FlutterAppData.instance = new FlutterAppData()
    }
    return FlutterAppData.instance
  }
  public start(): Promise<void> {
    // @ts-ignore
    // Accept the return from the App side
    window.receiveToken = (message: string) => {
      if (message !== '') {
        this.setAppData(message)
      }
      this.finishCallback()
    }
    return new Promise((resolve, reject) => {
      if (this.isInAppEnv()) {
        this.requestAppToken()
        this.finishCallback = resolve
      } else {
        resolve()
      }
    })
  }
  public isInAppEnv() {
    // @ts-ignore
    return !!window.AppMethod
  }
  // Delayed communication with app
  public finishCallback() {
    console.log('get app data successfully')
  }
  public setAppData(message: string) {
    localStorage.setItem('appToken', message)
  }
  public getAppData(): string | null {
    return localStorage.getItem('appToken')
  }
  public removeAppData() {
    localStorage.removeItem('appToken')
  }
  public requestAppToken() {
    if (this.isInAppEnv()) {
      const str = `{
          "name":"get_token",
          "params":"",
          "reponse":"receiveToken"
      }`
      // @ts-ignore
      window.AppMethod.postMessage(str)
    }
  }
  public evokeAppLogin() {
    if (this.isInAppEnv()) {
      const str = `{
          "name":"do_app_login",
          "params":""
      }`
      // @ts-ignore
      window.AppMethod.postMessage(str)
    }
  }
}

export default FlutterAppData.getInstance()
